"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackhaulTypes = exports.GatewayState = void 0;
/** Temp same as Device State as BO incomplete */
var GatewayState;
(function (GatewayState) {
    GatewayState["UNKNOWN"] = "UNKNOWN";
    GatewayState["COMMISSIONED"] = "COMMISSIONED";
    GatewayState["DECOMMISSONED"] = "DECOMMISSONED";
    GatewayState["SUSPENDED"] = "SUSPENDED";
    GatewayState["CALIBRATED"] = "CALIBRATED";
    GatewayState["TRANSITIN"] = "TRANSITIN";
    GatewayState["TRANSITOUT"] = "TRANSITOUT";
    GatewayState["WITHCUSTOMER"] = "WITHCUSTOMER";
    GatewayState["WITHENGINEER"] = "WITHENGINEER";
    GatewayState["INVENTORY"] = "INVENTORY";
    GatewayState["ORDEREDCUSTOMER"] = "ORDEREDCUSTOMER";
    GatewayState["ORDERED"] = "ORDERED";
    GatewayState["RETIRED"] = "RETIRED";
})(GatewayState || (exports.GatewayState = GatewayState = {}));
var BackhaulTypes;
(function (BackhaulTypes) {
    BackhaulTypes["Ethernet"] = "Ethernet";
    BackhaulTypes["Wi-Fi"] = "WiFi";
    BackhaulTypes["4G"] = "4G";
})(BackhaulTypes || (exports.BackhaulTypes = BackhaulTypes = {}));
